import { render, staticRenderFns } from "./VirtualTour.vue?vue&type=template&id=a813bc30&scoped=true"
import script from "./VirtualTour.vue?vue&type=script&lang=js"
export * from "./VirtualTour.vue?vue&type=script&lang=js"
import style0 from "./VirtualTour.vue?vue&type=style&index=0&id=a813bc30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a813bc30",
  null
  
)

export default component.exports